import { apiFetch, apiFetchLong } from './api';

/**
 * QCM : un test par TYPE — recrutement ('client', 'formateur') et une
 * évaluation par formation (migration 096) — avec ses versions et ses
 * questions à barème gradué ; les sections pondérées sont communes à tous.
 * Le scoring se fait côté serveur à la soumission.
 */

/**
 * Les types de QCM : { code, libelle, famille: 'recrutement' | 'evaluation',
 * formations: [{ id, code, intitule }] } — les formations du catalogue
 * auxquelles le type est rattaché.
 */
export function getTypesQcm() {
  return apiFetch('/qcm/types');
}

/** Remplace les formations du catalogue rattachées à un type de QCM. */
export function rattacherFormationsQcm(code, formationIds) {
  return apiFetch(`/qcm/types/${encodeURIComponent(code)}/formations`, {
    method: 'PUT',
    body: JSON.stringify({ formationIds }),
  });
}

/**
 * Lit un formulaire Tally (lien public tally.so/r/…) : renvoie le texte de
 * ses questions — barème du quiz compris — prêt pour l'analyse. Rien n'est
 * enregistré.
 */
export function lireFormulaireTally(lien) {
  return apiFetch('/qcm/import/tally', { method: 'POST', body: JSON.stringify({ lien }) });
}

/* ------- Sections (communes aux QCM clients et formateurs) ------- */

export function getSectionsQcm() {
  return apiFetch('/qcm/sections');
}

export function createSectionQcm(donnees) {
  return apiFetch('/qcm/sections', { method: 'POST', body: JSON.stringify(donnees) });
}

export function updateSectionQcm(code, donnees) {
  return apiFetch(`/qcm/sections/${encodeURIComponent(code)}`, {
    method: 'PUT',
    body: JSON.stringify(donnees),
  });
}

export function deleteSectionQcm(code) {
  return apiFetch(`/qcm/sections/${encodeURIComponent(code)}`, { method: 'DELETE' });
}

/* ---------------- Versions ---------------- */

export function getVersionsQcm(type) {
  return apiFetch(`/qcm/versions?type=${encodeURIComponent(type)}`);
}

export function createVersionQcm(donnees) {
  return apiFetch('/qcm/versions', { method: 'POST', body: JSON.stringify(donnees) });
}

export function updateVersionQcm(id, donnees) {
  return apiFetch(`/qcm/versions/${id}`, { method: 'PUT', body: JSON.stringify(donnees) });
}

export function dupliquerVersionQcm(id, donnees = {}) {
  return apiFetch(`/qcm/versions/${id}/dupliquer`, {
    method: 'POST',
    body: JSON.stringify(donnees),
  });
}

export function deleteVersionQcm(id) {
  return apiFetch(`/qcm/versions/${id}`, { method: 'DELETE' });
}

/* ---------------- Questions ---------------- */

export function getQuestionsQcm(versionId) {
  return apiFetch(`/qcm/versions/${versionId}/questions`);
}

export function createQuestionQcm(donnees) {
  return apiFetch('/qcm/questions', { method: 'POST', body: JSON.stringify(donnees) });
}

export function updateQuestionQcm(id, donnees) {
  return apiFetch(`/qcm/questions/${id}`, { method: 'PUT', body: JSON.stringify(donnees) });
}

export function deleteQuestionQcm(id) {
  return apiFetch(`/qcm/questions/${id}`, { method: 'DELETE' });
}

/* ---------------- Passages ---------------- */

export function getPassagesQcm({ type, versionId } = {}) {
  const params = new URLSearchParams({ type });
  if (versionId) params.set('versionId', versionId);
  return apiFetch(`/qcm/passages?${params}`);
}

export function getPassageQcm(id) {
  return apiFetch(`/qcm/passages/${id}`);
}

export function deletePassageQcm(id) {
  return apiFetch(`/qcm/passages/${id}`, { method: 'DELETE' });
}

export function getStatutsQcm() {
  return apiFetch('/qcm/statuts');
}

/* ---------------- Import par copier-coller ---------------- */

/** L'IA structure les questions ET choisit l'axe de chacune : { propositions }. */
export function analyserImportQcm({ typeQcm, texte }) {
  return apiFetchLong('/qcm/import/analyser', {
    method: 'POST',
    body: JSON.stringify({ typeQcm, texte }),
  });
}

/** Crée les questions relues ; sans versionId, une version neuve les reçoit. */
export function enregistrerImportQcm({ typeQcm, versionId, lignes, communes = [] }) {
  return apiFetch('/qcm/import/enregistrer', {
    method: 'POST',
    body: JSON.stringify({ typeQcm, versionId, lignes, communes }),
  });
}

/* ------- Questions communes du début de chaque évaluation ------- */

/** e-mail, NOM Prénom, formateur, entreprise… : { id, code, libelle, nature, obligatoire, ordre }. */
export function getChampsCommunsQcm() {
  return apiFetch('/qcm/champs-communs');
}

export function createChampCommunQcm(donnees) {
  return apiFetch('/qcm/champs-communs', { method: 'POST', body: JSON.stringify(donnees) });
}

export function updateChampCommunQcm(id, donnees) {
  return apiFetch(`/qcm/champs-communs/${id}`, { method: 'PUT', body: JSON.stringify(donnees) });
}

export function deleteChampCommunQcm(id) {
  return apiFetch(`/qcm/champs-communs/${id}`, { method: 'DELETE' });
}
